let shouldBypassCheckoutBackGuard = false;

export const bypassCheckoutBackGuardOnce = () => {
  shouldBypassCheckoutBackGuard = true;
};

export const consumeCheckoutBackGuardBypass = (): boolean => {
  if (!shouldBypassCheckoutBackGuard) {
    return false;
  }

  shouldBypassCheckoutBackGuard = false;
  return true;
};
